import * as Zod from 'zod';

export const ticketClassScheme = Zod.object({
  id: Zod.string(),
  label: Zod.string(),
});
